import React from 'react';
import "./ResourceMain.css";
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import ExpectedOutcomesAndResources from './rightresource';
const ResourceMain = () => {
  return (
    <div className={`container-fluid ${"learningResourceContainer"}`}>
      
      <div className="row">
        <div className="col-lg-8 col-md-7">
          <LeftSection />
        </div>
        <div className="col-lg-4 col-md-5">
          <RightSection />
        </div>
        <div className="col-lg-8 col-md-7">
          <ExpectedOutcomesAndResources />
        </div>

      </div>
    </div>
  );
};

export default ResourceMain;
